export default __webpack_public_path__ + "static/prevoyage-86379c5ec44949b0c9e6a2d016ab52c4.png";